import { render } from "./Index.vue?vue&type=template&id=bb22e8e8"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
script.render = render

export default script